import React from "react";
import { useDispatch } from "react-redux";
import {isBrowser, isMobile} from "react-device-detect";
import {openPharmacyOrderReadyModal} from "../../../../../redux/actions/modals";
import SafeCallComponent from "../../lab-orders/LabOrderItem/children/SafeCallComponent";

const PharmacyOrderPrepareOrderActions = (props) => {
    const dispatch = useDispatch();
    return (
        <>
            <div className="flex-column pharmacy-actions-buttons" style={isMobile ? {padding:'5px'} : {}}>
                <button
                    className="btn btn-small btn-success btn-accept margin-bottom-5"
                    onClick={() => {
                        dispatch(openPharmacyOrderReadyModal(props));
                    }}
                >
                    <div className="title">
                        نسخه آماده است
                    </div>
                </button>
               {/* {
                    isBrowser ? <SafeCallComponent order={props} /> : null
                }*/}
            </div>
        </>
    );
};
export default PharmacyOrderPrepareOrderActions;